module.exports = __webpack_public_path__ + "img/alabama-university-logo.3eaa4119.jpg";